export const ORDER_FIELD_NAME = `orderRank` as const

// same version we are using in the vision plugin
export const API_VERSION = `v2025-06-27` as const
